export const chapter4Translations = {
  name: "Розділ 4: Розп'яття та Воскресіння",
  description: "Слідкуйте за історією страждань, смерті та воскресіння Ісуса",
  spiritualWisdom: "Хрест є символом остаточного тріумфу любові та перемоги над гріхом. Воскресіння дає нам обіцянку нового життя у Христі.",
  
  levels: {
    40: {
      name: "Арешт",
      challenge: "Дізнайтеся про арешт Ісуса в Гефсиманському саду",
      
      questions: {
        easy: {
          question: "У якому саду був заарештований Ісус?",
          options: ["Гефсиманія", "Едем", "Оливна", "Назарет"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "Який знак використав Юда, щоб зрадити Ісуса?",
          options: ["Рукостискання", "Поцілунок", "Слово", "Жест"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Який учень відсік мечем вухо слуги первосвященика?",
          options: ["Яків", "Іван", "Петро", "Андрій"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Гефсиманія - це сад біля підніжжя Оливної гори",
        "Юда зрадив Ісуса за 30 срібняків",
        "Ісус чудесним чином зцілив вухо слуги"
      ],
      
      funFacts: [
        "Гефсиманія означає 'олійний прес', де виробляли оливкову олію",
        "Арешт Ісуса відбувся глибокої ночі",
        "Ісус пішов мирно, просячи учнів не чинити опору насильством"
      ]
    },

    41: {
      name: "Зречення Петра",
      challenge: "Дізнайтеся, як Петро тричі зрікся Ісуса",
      
      questions: {
        easy: {
          question: "Скільки разів Петро зрікся Ісуса?",
          options: ["Один раз", "Два рази", "Три рази", "Чотири рази"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Що сталося після третього зречення Петра?",
          options: ["Зійшло сонце", "Заспівав півень", "Блиснула блискавка", "Стався землетрус"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Де був Петро, коли зрікся Ісуса?",
          options: ["У храмі", "У дворі первосвященика", "У палаці Пилата", "У Гефсиманії"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ісус передбачив зречення Петра",
        "Петро гірко заплакав, усвідомивши, що зробив",
        "Все сталося тієї ж ночі"
      ],
      
      funFacts: [
        "Ісус сказав 'Перш ніж заспіває півень, тричі зречешся Мене'",
        "Зречення Петра - потужний приклад людської слабкості та божественного прощення",
        "Петро пізніше став великим лідером Церкви"
      ]
    },

    42: {
      name: "Ісус перед Пилатом",
      challenge: "Дізнайтеся про суд над Ісусом перед римським намісником",
      
      questions: {
        easy: {
          question: "Ким був Пилат?",
          options: ["Учнем", "Римським намісником", "Первосвящеником", "Фарисеєм"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Чого не знайшов Пилат в Ісусі?",
          options: ["Мудрості", "Провини", "Сміливості", "Сили"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Що зробив Пилат, щоб символізувати свою невинність?",
          options: ["Умив руки", "Роздер одяг", "Постився", "Молився"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Пилат хотів звільнити Ісуса",
        "Натовп вимагав розп'яття Ісуса",
        "Пилат піддався політичному тиску"
      ],
      
      funFacts: [
        "Дружина Пилата попередила його не робити нічого проти Ісуса",
        "Умивання рук було символом невинності в юдейській традиції",
        "Рішення Пилата показало провал людського правосуддя"
      ]
    },

    43: {
      name: "Варавва чи Ісус",
      challenge: "Дізнайтеся про вибір натовпу на користь Варавви",
      
      questions: {
        easy: {
          question: "Ким був Варавва?",
          options: ["Учнем", "Розбійником", "Священиком", "Царем"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Що міг зробити Пилат під час юдейського свята?",
          options: ["Звільнити одного в'язня", "Простити податки", "Влаштувати бенкет", "Закрити храм"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Кого вибрав натовп?",
          options: ["Ісуса", "Варавву", "Обох", "Нікого"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Це було свято Пасхи",
        "Натовп вимагав розп'яти Ісуса",
        "Варавва був вбивцею та бунтівником"
      ],
      
      funFacts: [
        "Ім'я Варавва означає 'син батька'",
        "Звільнення Варавви - символ жертви Христа",
        "Ми всі Варавва, звільнені жертвою Ісуса"
      ]
    },

    44: {
      name: "Биття та Терновий Вінець",
      challenge: "Дізнайтеся про страждання Ісуса",
      
      questions: {
        easy: {
          question: "Що воїни поклали на голову Ісуса?",
          options: ["Золоту корону", "Терновий вінець", "Вінок з квітів", "Тюрбан"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Як воїни знущалися над Ісусом?",
          options: ["Називаючи його царем", "Побиваючи камінням", "Ув'язнюючи", "Ігноруючи його"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Що містив римський бич?",
          options: ["Шкіряні смуги", "Шматки кісток та металу", "Тільки дерево", "Мотузку"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Биття було жорстоким римським покаранням",
        "Воїни одягли Ісуса в багряницю",
        "Ісус мовчки переніс все це"
      ],
      
      funFacts: [
        "Терновий вінець символізує прокляття гріха",
        "Багряний колір був царським кольором, використаним для насмішки",
        "Страждання Ісуса виконують пророцтва Ісаї"
      ]
    },

    45: {
      name: "Шлях на Голгофу",
      challenge: "Дізнайтеся, як Ісус ніс хрест",
      
      questions: {
        easy: {
          question: "Що ніс Ісус?",
          options: ["Прапор", "Хрест", "Корону", "Меч"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Хто допоміг Ісусу нести хрест?",
          options: ["Петро", "Іван", "Симон Киринеянин", "Йосип"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Що означає Голгофа?",
          options: ["Свята гора", "Місце черепа", "Місце миру", "Місце правосуддя"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ісус падав від слабкості",
        "Жінки плакали по дорозі",
        "Процесія пройшла через місто"
      ],
      
      funFacts: [
        "Хрест важив близько 40-50 кг",
        "Голгофа знаходилася за міськими стінами",
        "Симон Киринеянин прийшов з Африки"
      ]
    },

    46: {
      name: "Розп'яття",
      challenge: "Дізнайтеся про розп'яття Ісуса",
      
      questions: {
        easy: {
          question: "Зі скількома іншими людьми був розп'ятий Ісус?",
          options: ["Ні з ким", "З одним", "З двома", "З трьома"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Що сказав Ісус на хресті: 'Отче, ___ їм'?",
          options: ["Спаси", "Прости", "Зупини", "Покарай"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Який був напис на хресті?",
          options: ["Грішник", "Цар Юдейський", "Бунтівник", "Пророк"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ісус був розп'ятий о третій годині дня",
        "Воїни кидали жереб про його одяг",
        "Ісус промовив сім слів з хреста"
      ],
      
      funFacts: [
        "Напис був написаний трьома мовами: єврейською, латинською та грецькою",
        "Один із розбійників покаявся в останню мить",
        "Ісус доручив свою матір піклуванню Івана"
      ]
    },

    47: {
      name: "Смерть Ісуса",
      challenge: "Дізнайтеся про останні години Ісуса",
      
      questions: {
        easy: {
          question: "Що сталося в момент смерті Ісуса?",
          options: ["Сонце засяяло яскравіше", "Настала темрява", "Пішов дощ", "З'явилася веселка"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Що роздерлося в храмі?",
          options: ["Підлога", "Завіса", "Стіна", "Стеля"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Якими були останні слова Ісуса?",
          options: ["Звершилося", "Спрагнів", "Отче, в руки Твої віддаю дух Мій", "Чому Ти Мене залишив"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Темрява тривала три години",
        "Воїн пронизав списом бік Ісуса",
        "Сотник сказав 'Істинно Людина Ця була Син Божий'"
      ],
      
      funFacts: [
        "Завіса храму роздерлася зверху донизу, не рукою людини",
        "Це сталося під час Пасхи, коли приносився в жертву агнець",
        "Смерть Ісуса сплатила ціну гріха"
      ]
    },

    48: {
      name: "Поховання",
      challenge: "Дізнайтеся про поховання Ісуса",
      
      questions: {
        easy: {
          question: "У чию гробницю був покладений Ісус?",
          options: ["Петра", "Йосипа Аримафейського", "Никодима", "Лазаря"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "У що було загорнуте тіло Ісуса?",
          options: ["У багряницю", "У золоті одежі", "У біле полотно", "Без одягу"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "Що приніс Никодим для тіла Ісуса?",
          options: ["Масло", "Смирну та алое", "Воду", "Квіти"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Гробниця була висічена в новій скелі",
        "Великий камінь привалили до входу",
        "Вартові були поставлені охороняти гробницю"
      ],
      
      funFacts: [
        "Це була гробниця багатої людини, виконуючи пророцтво Ісаї",
        "Поховання було здійснене поспішно, бо наближалася субота",
        "Йосип був таємним учнем, який став сміливим"
      ]
    },

    49: {
      name: "Порожня Гробниця",
      challenge: "Дізнайтеся про відкриття ранку воскресіння",
      
      questions: {
        easy: {
          question: "Хто першим знайшов гробницю порожньою?",
          options: ["Петро", "Іван", "Жінки", "Вартові"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Де був камінь?",
          options: ["Розбитий", "Відвалений", "Все ще на місці", "Зник"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Скільки ангелів зустріли жінки в гробниці?",
          options: ["Жодного", "Одного", "Двох", "Трьох"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Це був ранок першого дня тижня",
        "Жінки прийшли помазати тіло Ісуса",
        "Ангели сповістили благу вість"
      ],
      
      funFacts: [
        "Жінки були першими свідками, що було революційною деталлю",
        "Петро та Іван побігли до гробниці",
        "Однієї порожньої гробниці було недостатньо, Ісус мав з'явитися"
      ]
    },

    50: {
      name: "Ісус з'являється Марії Магдалині",
      challenge: "Дізнайтеся про перше з'явлення Ісуса",
      
      questions: {
        easy: {
          question: "Кому першій з'явився Ісус після воскресіння?",
          options: ["Петру", "Івану", "Марії Магдалині", "Хомі"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "За кого Марія спочатку прийняла Ісуса?",
          options: ["За ангела", "За садівника", "За воїна", "За фарисея"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Що сказав Ісус Марії, коли вона впізнала Його?",
          options: ["Йди і сповісти", "Не торкайся Мене", "Не бійся", "Віруй"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Марія плакала біля гробниці",
        "Ісус покликав її на ім'я",
        "Він послав її сповістити братам"
      ],
      
      funFacts: [
        "Ісус вибрав жінку для свого першого з'явлення",
        "Марія стала першим апостолом",
        "Вона назвала Його 'Раббуні' (Учителю)"
      ]
    },

    51: {
      name: "На дорозі в Емаус",
      challenge: "Дізнайтеся про з'явлення Ісуса на дорозі",
      
      questions: {
        easy: {
          question: "Скільки учнів йшли в Емаус?",
          options: ["Один", "Два", "Три", "Чотири"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "Коли учні впізнали Ісуса?",
          options: ["Відразу", "Під час переламування хліба", "На дорозі", "Ніколи"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "Що пояснював їм Ісус по дорозі?",
          options: ["Майбутнє", "Писання", "Закон", "Чудеса"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Ісус йшов з ними як незнайомець",
        "Їхні серця палали, коли Він говорив",
        "Ісус зник, коли вони впізнали Його"
      ],
      
      funFacts: [
        "Емаус знаходився приблизно в 11 км від Єрусалиму",
        "Ісус показав їм, як всі Писання говорили про Нього",
        "Учні відразу побігли назад в Єрусалим"
      ]
    },

    52: {
      name: "З'явлення учням",
      challenge: "Дізнайтеся про з'явлення Ісуса в замкненій кімнаті",
      
      questions: {
        easy: {
          question: "Де були учні, коли з'явився Ісус?",
          options: ["У храмі", "На ринку", "У замкненій кімнаті", "У Гефсиманії"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "Що показав Ісус учням?",
          options: ["Свої рани", "Своє обличчя", "Свій одяг", "Світло"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "Якого учня не було першого разу?",
          options: ["Петра", "Івана", "Хоми", "Якова"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "Двері були замкнені через страх",
        "Ісус сказав 'Мир вам'",
        "Він дихнув на них і сказав 'Прийміть Духа Святого'"
      ],
      
      funFacts: [
        "Ісус їв з ними, щоб довести, що Він не привид",
        "Хома повірив тиждень потому",
        "Ісус з'являвся багато разів протягом 40 днів"
      ]
    }
  }
};
